import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartItem } from '@store/orders/orders.model';
import { DownloadPDFService } from '@root/reports/services/download-p-d-f.service';
import { MixpanelService } from '@shared/services/mixpanel.service';
@Component({
  selector: 'rlst-add-to-cart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddToCartComponent {
  @Input() cartItem: CartItem;
  @Input() reportIncludes: Array<string>;
  @Input() noReportExists: boolean;
  @Input() sampleReportTitle: string;
  @Output() addToCartClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() viewReportClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private readonly downloadPDFService: DownloadPDFService,
    private readonly mixpanelService: MixpanelService,
  ) { }
  
  public addToCart(): void {
    this.addToCartClicked.emit();
  }

  public viewReport(): void {
    this.viewReportClicked.emit();
  }
  
  public downloadSampleReport(): void {
    this.mixpanelService.track('Sample Report: ', {
      type: this.cartItem.displayName,
    });
    this.downloadPDFService.downloadPDF(this.sampleReportTitle);
  }
}
